/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GrantPromoCampaignManagerOptions,
  GrantPromoCampaignManagerStatus204,
  GrantPromoCampaignManagerStatus400,
  GrantPromoCampaignManagerStatus401,
  GrantPromoCampaignManagerStatus403,
  GrantPromoCampaignManagerStatus404,
  GrantPromoCampaignManagerStatus500,
} from '../types/GrantPromoCampaignManager'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { grantPromoCampaignManager } from '../clients/grantPromoCampaignManager'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const grantPromoCampaignManagerMutationKey = () =>
  [{ url: '/v1/promo_campaigns/:trading_challenge_id/managers/:manager_id' }] as const

export function grantPromoCampaignManagerMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = grantPromoCampaignManagerMutationKey()
  return mutationOptions<
    GrantPromoCampaignManagerStatus204,
    ResponseErrorConfig<
      | GrantPromoCampaignManagerStatus400
      | GrantPromoCampaignManagerStatus401
      | GrantPromoCampaignManagerStatus403
      | GrantPromoCampaignManagerStatus404
      | GrantPromoCampaignManagerStatus500
    >,
    GrantPromoCampaignManagerOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return grantPromoCampaignManager({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description ADMIN only. Idempotent PUT with no body. QR campaign grants are independent of home tenant and affiliate programs. Removal takes effect on the next protected request after commit; already authorized reads/downloads may finish. Batch issuance and removal serialize on the campaign lock.
 * @summary Grant QR campaign access for an Affiliate Manager
 * {@link /v1/promo_campaigns/:trading_challenge_id/managers/:manager_id}
 */
export function useGrantPromoCampaignManager<TContext>(
  options: {
    mutation?: UseMutationOptions<
      GrantPromoCampaignManagerStatus204,
      ResponseErrorConfig<
        | GrantPromoCampaignManagerStatus400
        | GrantPromoCampaignManagerStatus401
        | GrantPromoCampaignManagerStatus403
        | GrantPromoCampaignManagerStatus404
        | GrantPromoCampaignManagerStatus500
      >,
      GrantPromoCampaignManagerOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? grantPromoCampaignManagerMutationKey()

  const baseOptions = grantPromoCampaignManagerMutationOptions(config) as UseMutationOptions<
    GrantPromoCampaignManagerStatus204,
    ResponseErrorConfig<
      | GrantPromoCampaignManagerStatus400
      | GrantPromoCampaignManagerStatus401
      | GrantPromoCampaignManagerStatus403
      | GrantPromoCampaignManagerStatus404
      | GrantPromoCampaignManagerStatus500
    >,
    GrantPromoCampaignManagerOptions,
    TContext
  >

  return useMutation<
    GrantPromoCampaignManagerStatus204,
    ResponseErrorConfig<
      | GrantPromoCampaignManagerStatus400
      | GrantPromoCampaignManagerStatus401
      | GrantPromoCampaignManagerStatus403
      | GrantPromoCampaignManagerStatus404
      | GrantPromoCampaignManagerStatus500
    >,
    GrantPromoCampaignManagerOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    GrantPromoCampaignManagerStatus204,
    ResponseErrorConfig<
      | GrantPromoCampaignManagerStatus400
      | GrantPromoCampaignManagerStatus401
      | GrantPromoCampaignManagerStatus403
      | GrantPromoCampaignManagerStatus404
      | GrantPromoCampaignManagerStatus500
    >,
    GrantPromoCampaignManagerOptions,
    TContext
  >
}
